// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__Ry1py","content":"styles_content__2upxM","checkbox":"styles_checkbox__1KOmk","checkboxLabel":"styles_checkboxLabel__Eh7bk"};